<div class="fixActionRow">
    <mat-dialog-content>
        <div class="p-grid" fxLayout="column">
            <div fxLayout="row">
                <h2 mat-dialog-title>{{title}}</h2>
                <div fxFlex="1 1 auto"></div>
                <p *ngIf="reportDashboardMetricDefinition?.identifier" fxFlex="0 0 auto">
                    {{reportDashboardMetricDefinition.identifier}}</p>
            </div>
            <form [formGroup]="queryFormGroup" novalidate fxLayout="column">
                <mat-form-field>
                    <input matInput required placeholder="Name" name="queryName" formControlName="queryName"
                        maxlength="64">
                </mat-form-field>
                <mat-tab-group fxFlex="1 1 auto" (selectedIndexChange)="onTabIndexChange($event)">
                    <mat-tab label="Configuration" fxFlex="1 1 auto" fxLayout="column">
                        <div fxLayout="column">
                            <div fxLayout="column" [fxHide]="!data.isMetricDefinition">
                                <ng-container [ngTemplateOutlet]="metricType" [ngTemplateOutletContext]="{}">
                                </ng-container>
                            </div>
                            <div fxLayout="column">
                                <p fxLayout="row">
                                    <mat-button-toggle-group fxFlex="0 0 auto" color="primary" appearance="legacy"
                                        [disabled]="usePreset.value === true" formControlName="queryType"
                                        [fxHide]="data.isMetricDefinition && reportDashboardMetricDefinition.type !== 'QUERY_BASED'"
                                        (change)="onQueryTypeChange($event)">
                                        <mat-button-toggle *ngFor="let allowedQueryType of allowedQueryTypes"
                                            class="configuration-toggle-button" [value]="allowedQueryType.value">
                                            {{allowedQueryType.label}}
                                        </mat-button-toggle>
                                    </mat-button-toggle-group>
                                    <mat-checkbox [fxHide]="componentType.value === 'METRIC'"
                                        formControlName="usePreset" class="preset-checkbox"
                                        (change)="onUsePresetChange($event)">Use Preset
                                    </mat-checkbox>
                                    <span fxFlex="1 1 auto"></span>
                                    <mat-button-toggle-group [fxHide]="queryUsageDisabled" fxFlex="0 0 auto"
                                        color="primary" appearance="legacy" formControlName="queryUsage"
                                        (change)="onQueryUsageChange($event)">
                                        <!-- <mat-button-toggle [disabled]="!isReportDashboardComponentConfig"
                                        class="configuration-toggle-button" value="GRAPHICAL">Graphical
                                    </mat-button-toggle> -->
                                        <mat-button-toggle
                                            *ngIf="(license?.dashboard?.queryUsages || []).includes('DASHBOARD')"
                                            [disabled]="isQueryUsageDisabled('DASHBOARD', componentType.value)"
                                            class="configuration-toggle-button" value="DASHBOARD">Dashboard
                                        </mat-button-toggle>
                                        <mat-button-toggle
                                            [disabled]="isQueryUsageDisabled('INVENTORY', componentType.value)"
                                            *ngIf="(license?.dashboard?.queryUsages || []).includes('INVENTORY')"
                                            class="configuration-toggle-button" value="INVENTORY">Inventory
                                        </mat-button-toggle>
                                        <mat-button-toggle
                                            *ngIf="(license?.dashboard?.queryUsages || []).includes('INVESTIGATION')"
                                            [disabled]="isQueryUsageDisabled('INVESTIGATION', componentType.value)"
                                            class="configuration-toggle-button" value="INVESTIGATION">Investigation
                                        </mat-button-toggle>
                                        <mat-button-toggle
                                            *ngIf="(license?.dashboard?.queryUsages || []).includes('DOWNLOAD')"
                                            [disabled]="isQueryUsageDisabled('DOWNLOAD', componentType.value)"
                                            class="configuration-toggle-button" value="DOWNLOAD">Download
                                        </mat-button-toggle>
                                    </mat-button-toggle-group>
                                </p>
                                <div [fxHide]="usePreset.value === true" fxLayout="column">
                                    <p *ngIf="queryUsage.value === 'INVENTORY'">Note: Inventory component
                                        results
                                        will
                                        not be included inside the published or online report dashboard.
                                        They will appear as attachments in published distributions.
                                    </p>
                                    <p *ngIf="queryUsage.value === 'DOWNLOAD'">Note: Download component results will not
                                        be
                                        included inside the published or online report dashboard.</p>
                                    <p *ngIf="queryUsage.value === 'INVESTIGATION'">Note: Investigation component
                                        results
                                        will
                                        not be included inside the published or online report dashboard.</p>
                                    <p fxLayout="row" *ngIf="isReportDashboardComponentConfig"
                                        [fxHide]="componentTypeDisabled">
                                        <mat-button-toggle-group fxFlex="0 0 auto" color="primary" appearance="legacy"
                                            formControlName="componentType" (change)="onComponentTypeChange($event)">
                                            <mat-button-toggle [disabled]="queryUsage.value !== 'DASHBOARD'"
                                                class="configuration-toggle-button" value="PIVOT">Pivot
                                            </mat-button-toggle>
                                            <mat-button-toggle class="configuration-toggle-button" value="TABLE">Table
                                            </mat-button-toggle>
                                            <!-- <mat-button-toggle class="configuration-toggle-button"
                                                value="PROPERTY_TABLE">Property Table
                                            </mat-button-toggle> -->
                                            <mat-button-toggle [disabled]="queryUsage.value !== 'DASHBOARD'"
                                                class="configuration-toggle-button" value="CHART">Chart
                                            </mat-button-toggle>
                                            <mat-button-toggle [disabled]="queryUsage.value === 'INVENTORY'"
                                                class="configuration-toggle-button" value="COMPARISON_TABLE">
                                                Comparison
                                            </mat-button-toggle>
                                            <!-- <mat-button-toggle [disabled]="queryUsage.value !== 'DASHBOARD'" class="configuration-toggle-button" value="TEXT">
                                        Text Box
                                    </mat-button-toggle> -->
                                        </mat-button-toggle-group>
                                        <span fxFlex="1 1 auto"></span>
                                        <mat-button-toggle-group [fxHide]="componentType.value != 'CHART'"
                                            [disabled]="componentType.value != 'CHART'" fxFlex="0 0 auto"
                                            color="primary" appearance="legacy" formControlName="chartType"
                                            (change)="onChartTypeChange($event)">
                                            <mat-button-toggle class="configuration-toggle-button" value="PIE">Pie
                                            </mat-button-toggle>
                                            <mat-button-toggle class="configuration-toggle-button" value="BAR">Bar
                                            </mat-button-toggle>
                                            <mat-button-toggle class="configuration-toggle-button" value="COLUMN">Column
                                            </mat-button-toggle>
                                            <!-- <mat-button-toggle class="configuration-toggle-button" value="LINE">Line
                                    </mat-button-toggle> -->
                                        </mat-button-toggle-group>
                                    </p>
                                    <div fxLayout="row"
                                        *ngIf="availableAttributeColumns && componentType.value === 'CHART'">
                                        <button mat-icon-button (click)="openColumnChooserDialog('CHART_ATTRIBUTE')">
                                            <mat-icon>search</mat-icon>
                                        </button>
                                        <mat-form-field fxFlex="1 1 auto">
                                            <mat-label>Attribute</mat-label>
                                            <mat-select formControlName="attributeColumn">
                                                <mat-option *ngFor="let attributeColumn of availableAttributeColumns"
                                                    [value]="attributeColumn.value" #attributeOption>
                                                    {{attributeColumn.label}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <mat-form-field
                                        *ngIf="availableAttributeColumns && (componentType.value === 'TABLE' || componentType.value === 'COMPARISON_TABLE')">
                                        <mat-label>Attributes</mat-label>
                                        <app-chooser-bar fxFlex="1 1 100%" [maxAllowed]="maxAttributes"
                                            formControlName="attributeColumns" [items]="availableAttributeColumns">
                                        </app-chooser-bar>
                                    </mat-form-field>
                                    <mat-form-field *ngIf="componentType.value === 'PIVOT'">
                                        <mat-label>Row Attributes</mat-label>
                                        <app-chooser-bar *ngIf="availableAttributeColumns" fxFlex="1 1 100%"
                                            [maxAllowed]="maxAttributes" formControlName="pivotRowColumns"
                                            [items]="availableAttributeColumns"></app-chooser-bar>
                                    </mat-form-field>
                                    <mat-form-field *ngIf="componentType.value === 'PIVOT'">
                                        <mat-label>Column Attributes</mat-label>
                                        <app-chooser-bar *ngIf="availableAttributeColumns" fxFlex="1 1 100%"
                                            [maxAllowed]="maxAttributes" formControlName="pivotColColumns"
                                            [items]="availableAttributeColumns"></app-chooser-bar>
                                    </mat-form-field>
                                    <div fxLayout="row" *ngIf="componentType.value === 'CHART'">
                                        <button mat-icon-button (click)="openColumnChooserDialog('CHART_VALUE')">
                                            <mat-icon>search</mat-icon>
                                        </button>
                                        <mat-form-field fxFlex="1 1 auto">
                                            <mat-label>Value</mat-label>
                                            <mat-select formControlName="valueColumn">
                                                <mat-option *ngFor="let valueColumn of availableValueColumns"
                                                    [value]="valueColumn.value" #valueOption>
                                                    {{valueColumn.label}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <mat-form-field
                                        *ngIf="componentType.value === 'TABLE' || componentType.value === 'COMPARISON_TABLE' || componentType.value === 'PIVOT'  || (data.isMetricDefinition && reportDashboardMetricDefinition.type === 'QUERY_BASED')">
                                        <mat-label>Values</mat-label>
                                        <app-chooser-bar fxFlex="1 1 100%" *ngIf="availableValueColumns"
                                            [maxAllowed]="maxValues" formControlName="valueColumns"
                                            [items]="availableValueColumns"></app-chooser-bar>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div *ngIf="usePreset.value === true" fxLayout="row">
                                <mat-form-field fxFlex="1 1 75%">
                                    <mat-select placeholder="Preset" formControlName="presetDefinition"
                                        (selectionChange)="onPresetChoiceChange($event)">
                                        <mat-optgroup *ngFor="let group of availablePresetChoiceGroups"
                                            [label]="group.groupName">
                                            <mat-option *ngFor="let presetChoice of group.presetChoices"
                                                [value]="presetChoice.value" #valueOption>
                                                {{presetChoice.label}}</mat-option>
                                        </mat-optgroup>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div fxLayout="column" [fxHide]="usePreset.value === false">
                                <ng-container [ngTemplateOutlet]="presetOptions"
                                    [ngTemplateOutletContext]="{modulus: 0}"></ng-container>
                            </div>
                            <div fxLayout="column" [fxHide]="!data.isMetricDefinition">
                                <ng-container [ngTemplateOutlet]="metricFields" [ngTemplateOutletContext]="{}">
                                </ng-container>
                            </div>
                            <fieldset fxFlex="1 1 auto" fxLayout="column" class="field-set"
                                [fxHide]="!isHistoricalSeriesAllowed()">
                                <legend>Series settings</legend>
                                <div fxLayout="column">
                                    <mat-form-field class="series-settings-mat-form-field">
                                        <mat-select placeholder="Frequency" formControlName="historicalFrequency">
                                            <mat-option [value]="'NONE'">None</mat-option>
                                            <mat-option [value]="'DAILY'">Daily</mat-option>
                                            <mat-option [value]="'WEEKLY'">Weekly</mat-option>
                                            <mat-option [value]="'MONTHLY'">Monthly</mat-option>
                                            <mat-option [value]="'QUARTERLY'">Quarterly</mat-option>
                                            <mat-option [value]="'SPECIFIC'">Specific</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field [fxHide]="historicalFrequency.value !== 'SPECIFIC'"
                                        class="series-settings-mat-form-field" floatLabel="always">
                                        <mat-label>Specific Dates</mat-label>
                                        <app-chooser-bar fxFlex="1 1 100%" fxLayout="row" [maxAllowed]="30"
                                            [chooserBarType]="'DATE'" formControlName="historicalSpecificDates"
                                            [items]="[]">
                                        </app-chooser-bar>
                                    </mat-form-field>
                                    <div class="check-box-wrapper" fxFlex="1 1 20%" fxLayout="row"
                                        class="series-settings-mat-form-field">
                                        <mat-checkbox formControlName="historicalAlwaysIncludeOperatingDate">Always
                                            include
                                            operating
                                            date</mat-checkbox>
                                    </div>
                                    <mat-form-field
                                        [fxHide]="historicalFrequency.value === 'SPECIFIC' || historicalFrequency.value === 'NONE'"
                                        class="series-settings-mat-form-field">
                                        <mat-select placeholder="# of Points"
                                            formControlName="historicalNumberOfPoints">
                                            <mat-option [value]="'FROM_SOM'">From Start of Month</mat-option>
                                            <mat-option *ngFor="let item of [].constructor(30); let i=index "
                                                [value]="(i+1) + ''">{{i+1}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <div class="spacer"></div>
                                </div>
                            </fieldset>
                        </div>
                    </mat-tab>
                    <mat-tab fxFlex="1 1 auto" fxLayout="column" label="Source Filters"
                        [disabled]="sourceFiltersDisabled || componentType.value === 'TEXT'">
                        <div fxFlex="1 1 auto" fxLayout="column">
                            <app-report-dashboard-query-filter #sourceFilterComponent
                                [columnGroupLabels]="['Attributes','Values']"
                                [columnGroups]="sourceQueryFilterColumnGroups" [distinctValues]="distinctValues"
                                [customerColumnAliases]="customerColumnAliases">
                            </app-report-dashboard-query-filter>
                            <!-- <fieldset fxFlex="1 1 auto" fxLayout="column">
                                <legend>Add/Edit</legend>
                                <div fxFlex="1 1 auto" fxLayout="row">
                                    <button mat-icon-button (click)="openColumnChooserDialog('SOURCE_FILTER')">
                                        <mat-icon>search</mat-icon>
                                    </button>
                                    <mat-form-field fxFlex="1 1 35%" floatLabel="always">
                                        <mat-label>Column</mat-label>
                                        <mat-select formControlName="sourceFilterColumn">
                                            <mat-optgroup label="Attributes">
                                                <mat-option *ngFor="let attributeColumn of availableAttributeColumns"
                                                    [value]="attributeColumn.value">
                                                    {{attributeColumn.label}}</mat-option>
                                            </mat-optgroup>
                                            <mat-optgroup label="Values">
                                                <mat-option *ngFor="let valueColumn of availableValueColumns"
                                                    [value]="valueColumn.value">
                                                    {{valueColumn.label}}</mat-option>
                                            </mat-optgroup>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field fxFlex="0 1 15%" floatLabel="always">
                                        <mat-label>Operator</mat-label>
                                        <mat-select formControlName="sourceFilterOperator">
                                            <mat-option *ngFor="let operator of operators" [value]="operator.value">
                                                {{operator.label}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field fxFlex="1 1 35%" floatLabel="always"
                                        [fxHide]="sourceFilterOperator.value === 'BETWEEN' || sourceFilterOperator.value === 'NOT_BETWEEN'
                                        || sourceFilterOperator.value === 'EMPTY' || sourceFilterOperator.value === 'NOT_EMPTY'">
                                        <textarea matInput placeholder="Value" formControlName="sourceFilterValue"
                                            *ngIf="!distinctValues || !sourceFilterColumn.value || !distinctValues[sourceFilterColumn.value]"
                                            name="sourceFilterValue"></textarea>
                                        <ng-container
                                            *ngIf="distinctValues && sourceFilterColumn.value && distinctValues[sourceFilterColumn.value]">
                                            <mat-select placeholder="Value" formControlName="sourceFilterValue"
                                                name="sourceFilterValue"
                                                *ngIf="sourceFilterOperator.value !== 'IN' && sourceFilterOperator.value !== 'NOT_IN'">
                                                <mat-option
                                                    *ngFor="let option of distinctValues[sourceFilterColumn.value]"
                                                    [value]="option">
                                                    {{ option }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-select placeholder="Value" formControlName="sourceFilterInValues"
                                                name="sourceFilterInValues"
                                                *ngIf="sourceFilterOperator.value === 'IN' || sourceFilterOperator.value === 'NOT_IN'"
                                                multiple>
                                                <mat-option
                                                    *ngFor="let option of distinctValues[sourceFilterColumn.value].sort()"
                                                    [value]="option">
                                                    {{ option }}
                                                </mat-option>
                                            </mat-select>
                                        </ng-container>
                                    </mat-form-field>

                                    <mat-form-field fxFlex="1 1 15%" floatLabel="always"
                                        [fxHide]="sourceFilterOperator.value !== 'BETWEEN' && sourceFilterOperator.value !== 'NOT_BETWEEN'">
                                        <input matInput placeholder="Between"
                                            formControlName="sourceFilterBetweenValue1"
                                            name="sourceFilterBetweenValue1">
                                    </mat-form-field>
                                    <mat-form-field fxFlex="1 1 15%" floatLabel="always"
                                        [fxHide]="sourceFilterOperator.value !== 'BETWEEN' && sourceFilterOperator.value !== 'NOT_BETWEEN'">
                                        <input matInput placeholder="and" formControlName="sourceFilterBetweenValue2"
                                            name="sourceFilterBetweenValue2">
                                    </mat-form-field>

                                    <button mat-icon-button aria-label="Add Filter" (click)="addSourceFilter($event)">
                                        <mat-icon>add</mat-icon>
                                    </button>
                                    <button mat-icon-button aria-label="Delete Filter"
                                        (click)="deleteSourceFilter($event)">
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                </div>
                            </fieldset>
                            <fieldset fxFlex="1 1 auto" fxLayout="column">
                                <legend>Enabled Filters</legend>
                                <mat-table fxFlex="1 1 auto" #sourceFilterTable [dataSource]="sourceFilterDataSource"
                                    class="mat-elevation-z8 filter-table">
                                    <ng-container matColumnDef="column">
                                        <mat-header-cell *matHeaderCellDef>Column</mat-header-cell>
                                        <mat-cell *matCellDef="let element">
                                            {{aliasedColumnName(element.attributeColumn)}}
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="operator">
                                        <mat-header-cell *matHeaderCellDef>Operator</mat-header-cell>>
                                        <mat-cell *matCellDef="let element"> {{element.operator}} </mat-cell>>
                                    </ng-container>
                                    <ng-container matColumnDef="value">
                                        <mat-header-cell *matHeaderCellDef>Value</mat-header-cell>
                                        <mat-cell *matCellDef="let element"> {{element.value}} </mat-cell>
                                    </ng-container>
                                    <mat-row *matRowDef="let row; columns: ['column','operator','value']"
                                        (click)="onSourceFilterSelect(row)"
                                        [style.background]="sourceFilterSelection.isSelected(row) ? '#30bceb' : ''">
                                    </mat-row>
                                </mat-table>
                            </fieldset> -->
                        </div>
                    </mat-tab>
                    <mat-tab fxFlex="1 1 auto" fxLayout="column" label="Result Filters"
                        [disabled]="resultFiltersDisabled || componentType.value === 'TEXT'">
                        <div fxLayout="column">
                            <app-report-dashboard-query-filter #resultFilterComponent [columnGroupLabels]="['Values']"
                                [columnGroups]="resultQueryFilterColumnGroups" [distinctValues]="distinctValues"
                                [customerColumnAliases]="customerColumnAliases">
                            </app-report-dashboard-query-filter>

                            <!-- <fieldset fxFlex="1 1 auto" fxLayout="column">
                                <legend>Add/Edit</legend>
                                <div fxFlex="1 1 auto" fxLayout="row">
                                    <button mat-icon-button (click)="openColumnChooserDialog('RESULT_FILTER')">
                                        <mat-icon>search</mat-icon>
                                    </button>
                                    <mat-form-field fxFlex="1 1 35%" floatLabel="always">
                                        <mat-label>Column</mat-label>
                                        <mat-select formControlName="resultFilterColumn">
                                            <mat-option *ngFor="let valueColumn of availableResultValueColumns"
                                                [value]="valueColumn.value">
                                                {{valueColumn.label}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field fxFlex="1 1 15%" floatLabel="always">
                                        <mat-label>Operator</mat-label>
                                        <mat-select formControlName="resultFilterOperator">
                                            <mat-option *ngFor="let operator of operators" [value]="operator.value">
                                                {{operator.label}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field fxFlex="1 1 35%" floatLabel="always"
                                        [fxHide]="resultFilterOperator.value === 'BETWEEN' || resultFilterOperator.value === 'NOT_BETWEEN'">
                                        <input matInput placeholder=" Value" formControlName="resultFilterValue"
                                            name="resultFilterValue">
                                    </mat-form-field>
                                    <mat-form-field fxFlex="1 1 15%" floatLabel="always"
                                        [fxHide]="resultFilterOperator.value !== 'BETWEEN' && resultFilterOperator.value !== 'NOT_BETWEEN'">
                                        <input matInput placeholder="Between"
                                            formControlName="resultFilterBetweenValue1"
                                            name="resultFilterBetweenValue1">
                                    </mat-form-field>
                                    <mat-form-field fxFlex="1 1 15%" floatLabel="always"
                                        [fxHide]="resultFilterOperator.value !== 'BETWEEN' && resultFilterOperator.value !== 'NOT_BETWEEN'">
                                        <input matInput placeholder="and" formControlName="resultFilterBetweenValue2"
                                            name="resultFilterBetweenValue2">
                                    </mat-form-field>
                                    <button mat-icon-button aria-label="Add Filter" (click)="addResultFilter($event)">
                                        <mat-icon>add</mat-icon>
                                    </button>
                                    <button mat-icon-button aria-label="Delete Filter"
                                        (click)="deleteResultFilter($event)">
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                </div>
                            </fieldset>
                            <fieldset fxFlex="1 1 auto" fxLayout="column">
                                <legend>Enabled Filters</legend>
                                <mat-table #resultFilterTable [dataSource]="resultFilterDataSource"
                                    class="mat-elevation-z8 filter-table">
                                    <ng-container matColumnDef="column">
                                        <mat-header-cell *matHeaderCellDef>Column</mat-header-cell>
                                        <mat-cell *matCellDef="let element">
                                            {{aliasedColumnName(element.attributeColumn)}}
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="operator">
                                        <mat-header-cell *matHeaderCellDef>Operator</mat-header-cell>>
                                        <mat-cell *matCellDef="let element"> {{element.operator}} </mat-cell>>
                                    </ng-container>
                                    <ng-container matColumnDef="value">
                                        <mat-header-cell *matHeaderCellDef>Value</mat-header-cell>
                                        <mat-cell *matCellDef="let element"> {{element.value}} </mat-cell>
                                    </ng-container>
                                    <mat-row *matRowDef="let row; columns: ['column','operator','value']"
                                        (click)="onResultFilterSelect(row)"
                                        [style.background]="resultFilterSelection.isSelected(row) ? '#30bceb' : ''">
                                    </mat-row>
                                </mat-table>
                            </fieldset> -->
                        </div>
                    </mat-tab>
                    <mat-tab fxFlex="1 1 auto" fxLayout="column" label="Fields" [disabled]="fieldDisplaysDisabled"
                        [fxHide]="componentType.value === 'TEXT'">


                        <div fxLayout="row"
                            *ngIf="reportDashboardComponentConfig && reportDashboardComponentConfig.fieldDisplays">
                            <!-- <p-card fxFlex="1 5 20%" class="liquitics-box2"> -->
                            <!-- <p-table [value]="reportDashboardComponentConfig.fieldDisplays" selectionMode="single"
                                    [(selection)]="selectedFieldDisplay" dataKey="field">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th>Column</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-fieldDisplay>
                                        <tr [pSelectableRow]="fieldDisplay">
                                            <td>{{customerColumnAliases[fieldDisplay.field] ||
                                                optionLabelToDisplayName(fieldDisplay.field)}}</td>
                                        </tr>
                                    </ng-template>
                                </p-table> -->
                            <p-listbox fxFlex="1 5 20%" [listStyle]="{'height':'45vh'}" class="field-display-list"
                                [options]="reportDashboardComponentConfig.fieldDisplays" formControlName="fieldDisplay"
                                optionLabel="field" (onChange)="onFieldDisplaySelected($event)">
                                <ng-template let-fieldDisplay pTemplate="item">
                                    {{customerColumnAliases[fieldDisplay.field] ||
                                    optionLabelToDisplayName(fieldDisplay.field)}}
                                </ng-template>
                            </p-listbox>


                            <!-- </p-card> -->
                            <p-card fxFlex="5 1 80%" class="field-display-attributes" [style]="{'height':'45vh'}">
                                <div fxLayout="column" *ngIf="selectedFieldDisplay">
                                    <mat-form-field>
                                        <input matInput
                                            [placeholder]="'Display Name for: ' + (customerColumnAliases[selectedFieldDisplay.field] || selectedFieldDisplay.field)"
                                            name="selectedFieldDisplay.displayName"
                                            [value]="selectedFieldDisplay.displayName"
                                            (input)="selectedFieldDisplay.displayName = $event.target.value">
                                    </mat-form-field>
                                    <div fxLayout="row">
                                        <mat-form-field fxFlex="1 1 auto">
                                            <mat-select placeholder="Sort" [value]="selectedFieldDisplay.sortPriority"
                                                [(value)]="selectedFieldDisplay.sortPriority">
                                                <mat-option [value]="0">None</mat-option>
                                                <mat-option [value]="1">First</mat-option>
                                                <mat-option [value]="2">Second</mat-option>
                                                <mat-option [value]="3">Third</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field fxFlex="1 1 auto">
                                            <mat-select placeholder="Direction"
                                                [value]="selectedFieldDisplay.sortDescending"
                                                [(value)]="selectedFieldDisplay.sortDescending">
                                                <mat-option [value]="false">Ascending</mat-option>
                                                <mat-option [value]="true">Descending</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div fxLayout="row">
                                        <mat-form-field [fxHide]="isAttributeColumn(selectedFieldDisplay.field)"
                                            fxFlex="1 1 auto">
                                            <mat-select placeholder="Units" [value]="selectedFieldDisplay.amountUnit"
                                                [(value)]="selectedFieldDisplay.amountUnit">
                                                <mat-option [value]="'AMOUNT'">Amount</mat-option>
                                                <mat-option [value]="'THOUSAND'">Thousand</mat-option>
                                                <mat-option [value]="'MILLION'">Million</mat-option>
                                                <mat-option [value]="'BILLION'">Billion</mat-option>
                                                <mat-option [value]="'LAKH'">Lakh</mat-option>
                                                <mat-option [value]="'CRORE'">Crore</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field [fxHide]="isAttributeColumn(selectedFieldDisplay.field)"
                                            fxFlex="1 1 auto">
                                            <input matInput type="number" min="0" max="6" placeholder="Decimals"
                                                name="selectedFieldDisplay.amountDecimals"
                                                [value]="selectedFieldDisplay.amountDecimals"
                                                (input)="setAmountDecimalsOnFieldDisplay(selectedFieldDisplay, $event.target.value)">
                                        </mat-form-field>
                                    </div>
                                    <mat-form-field [fxHide]="!isDateColumn(selectedFieldDisplay.field)">
                                        <mat-select placeholder="Date Format" [value]="selectedFieldDisplay.dateFormat"
                                            [(value)]="selectedFieldDisplay.dateFormat">
                                            <mat-option [value]="'YYYY-MM-DD'">YYYY-MM-DD (2020-01-31)</mat-option>
                                            <mat-option [value]="'MM-DD-YYYY'">MM-DD-YYYY (01-31-2020)</mat-option>
                                            <mat-option [value]="'DD-MM-YYYY'">DD-MM-YYYY (31-01-2020)</mat-option>
                                            <mat-option [value]="'MM-DD'">MM-DD (01-31)</mat-option>
                                            <mat-option [value]="'DD-MM'">DD-MM (31-01)</mat-option>
                                            <mat-option [value]="'MMM DD'">MMM DD (Jan 31)</mat-option>
                                            <mat-option [value]="'DD MMM'">DD MMM (31 Jan)</mat-option>
                                            <mat-option [value]="'MM-YYYY'">MM-YYYY (01-2020)</mat-option>
                                            <mat-option [value]="'YYYY-MM'">YYYY-MM (2020-01)</mat-option>
                                            <mat-option [value]="'MMM YYYY'">MMM YYYY (Jan 2020)</mat-option>
                                            <mat-option [value]="'YYYY MMM'">YYYY MMM (2020 Jan)</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <div fxLayout="row" [fxHide]="!isDateColumn(selectedFieldDisplay.field)">
                                        <mat-form-field fxFlex="1 1 80%">
                                            <mat-label>Bucket Tenors</mat-label>
                                            <app-chooser-bar #bucketTenorChooserBar fxFlex="1 1 100%" [maxAllowed]="30"
                                                [chooserBarType]="'TENOR'" [items]="[]"
                                                [value]="selectedFieldDisplay.bucketTenors">
                                            </app-chooser-bar>
                                        </mat-form-field>
                                        <!-- <div class="check-box-wrapper" fxFlex="0 0 auto"> -->
                                        <div class="check-box-wrapper" fxFlex="1 1 20%" fxLayout="row">
                                            <mat-checkbox fxFlex="1 1 auto"
                                                [checked]="selectedFieldDisplay.isReverseBucketing"
                                                (change)="onReverseBucketingChanged($event, selectedFieldDisplay)">
                                                Reverse
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                    <!-- </div> -->
                                    <mat-form-field
                                        [fxHide]="!isAttributeColumn(selectedFieldDisplay.field) && (componentType.value !== 'TABLE' || componentType.value !== 'COMPARISON_TABLE')">
                                        <mat-select placeholder="Totalling" [value]="selectedFieldDisplay.totalType"
                                            [(value)]="selectedFieldDisplay.totalType">
                                            <mat-option [value]="'NONE'">None</mat-option>
                                            <mat-option [value]="'COLUMN_SUB_TOTAL'">Column Subtotal</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <div fxLayout="row">
                                        <mat-form-field [fxHide]="isAttributeColumn(selectedFieldDisplay.field)"
                                            fxFlex="1 1 50%">
                                            <mat-select placeholder="Totalling" [value]="selectedFieldDisplay.totalType"
                                                [(value)]="selectedFieldDisplay.totalType">
                                                <mat-option [value]="'NONE'">None</mat-option>
                                                <mat-option *ngIf="componentType.value === 'PIVOT'"
                                                    [value]="'COLUMN_SUB_TOTAL'">
                                                    Column Subtotal</mat-option>
                                                <mat-option [value]="'COLUMN_TOTAL'">Column Total</mat-option>
                                                <mat-option *ngIf="componentType.value === 'PIVOT'"
                                                    [value]="'ROW_TOTAL'">
                                                    Row
                                                    Total</mat-option>
                                                <mat-option *ngIf="componentType.value === 'PIVOT'"
                                                    [value]="'COLUMN_SUB_TOTAL_AND_TOTAL'">Column Sub & Total
                                                </mat-option>
                                                <mat-option *ngIf="componentType.value === 'PIVOT'"
                                                    [value]="'COLUMN_SUB_TOTAL_AND_ROW_TOTAL'">Column Sub & Row
                                                </mat-option>
                                                <mat-option *ngIf="componentType.value === 'PIVOT'"
                                                    [value]="'COLUMN_TOTAL_AND_ROW_TOTAL'">Column & Row Total
                                                </mat-option>
                                                <mat-option *ngIf="componentType.value === 'PIVOT'" [value]="'ALL'">All
                                                </mat-option>
                                                <mat-option
                                                    *ngIf="isRunningTotalSupported(selectedFieldDisplay.field)?.isSupported"
                                                    [value]="'RUNNING_TOTAL'">Running Total
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field [fxHide]="isAttributeColumn(selectedFieldDisplay.field)"
                                            fxFlex="1 1 50%">
                                            <mat-select placeholder="Convert to"
                                                [value]="selectedFieldDisplay.convertTo"
                                                [(value)]="selectedFieldDisplay.convertTo">
                                                <mat-option [value]="'NONE'">None</mat-option>
                                                <mat-option [value]="'INR'">INR</mat-option>
                                                <mat-option [value]="'USD'">USD</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <mat-form-field
                                        [fxHide]="componentType.value !== 'COMPARISON_TABLE' || isAttributeColumn(selectedFieldDisplay.field)">
                                        <mat-select placeholder="Show" [value]="selectedFieldDisplay.comparisonDisplay"
                                            [(value)]="selectedFieldDisplay.comparisonDisplay">
                                            <mat-option [value]="'CURRENT_PREV_CHANGE'">Current, Prev & Change
                                            </mat-option>
                                            <mat-option [value]="'CURRENT_CHANGE'">Current & Change</mat-option>
                                            <mat-option [value]="'CHANGE'">Change</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </p-card>
                        </div>

                    </mat-tab>
                    <mat-tab fxFlex="1 1 auto" fxLayout="column" label="Component Display"
                        [disabled]="componentDisplaysDisabled" [fxHide]="componentType.value === 'TEXT'">
                        <p-card [fxHide]="displayExtraOptionsDisabled">
                            <p-header>Options</p-header>
                            <div fxLayout="column">
                                <mat-form-field>
                                    <input matInput placeholder="Header Text" name="headerText"
                                        formControlName="headerText" maxlength="512">
                                </mat-form-field>
                                <mat-form-field>
                                    <input matInput placeholder="Footer Text" name="footerText"
                                        formControlName="footerText" maxlength="512">
                                </mat-form-field>
                                <div fxFlex="0 0 auto" fxLayout="row">
                                    <div class="check-box-wrapper" fxFlex="0 0 auto">
                                        <mat-checkbox formControlName="useFullWidth"
                                            (change)="onUseFullWidthChange($event)">On
                                            Dedicated Row
                                        </mat-checkbox>
                                    </div>
                                    <mat-button-toggle-group color="primary" appearance="legacy"
                                        [disabled]="fullWidth.value != true" formControlName="fillerColspan"
                                        fxFlex="0 0 auto">
                                        <mat-button-toggle class="configuration-toggle-button" value=0>Full
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value=3>3/4
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value=6>1/2
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value=9>1/4
                                        </mat-button-toggle>
                                    </mat-button-toggle-group>
                                </div>
                                <p fxFlex="0 0 auto">
                                    <mat-label>Aspect Ratio: </mat-label>
                                    <mat-button-toggle-group color="primary" appearance="legacy"
                                        formControlName="aspectRatio" (change)="onAspectRatioChange($event)">
                                        <mat-button-toggle class="configuration-toggle-button" value="EXTRA_TALL">Extra
                                            Narrow
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value="TALL">Narrow
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value="SQUARE">Square
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value="WIDE">Wide
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value="EXTRA_WIDE">Extra
                                            Wide
                                        </mat-button-toggle>
                                    </mat-button-toggle-group>
                                </p>
                                <p fxFlex="0 0 auto">
                                    <mat-label>Text Scaling: </mat-label>
                                    <mat-button-toggle-group color="primary" appearance="legacy"
                                        formControlName="textScaling">
                                        <mat-button-toggle class="configuration-toggle-button" value="NONE">Default
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value="X_SMALL">XSM
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value="SMALL">Small
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value="LARGE">Large
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value="X_LARGE">XL
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value="2X_LARGE">2XL
                                        </mat-button-toggle>
                                        <mat-button-toggle class="configuration-toggle-button" value="3X_LARGE">3XL
                                        </mat-button-toggle>
                                    </mat-button-toggle-group>
                                </p>
                            </div>
                        </p-card>
                    </mat-tab>
                    <mat-tab fxFlex="1 1 auto" fxLayout="column" label="Additional options"
                        [disabled]="additionalOptionsDisabled || componentType.value === 'TEXT'">
                        <div fxLayout="column">
                            <!-- <div fxLayout="row">
                                <mat-form-field fxFlex="1 1 50%">
                                    <mat-label>Sort by</mat-label>
                                    <mat-select formControlName="sortByColumn">
                                        <mat-option *ngFor="let attributeColumn of availableAttributeColumns"
                                            [value]="attributeColumn.value">
                                            {{attributeColumn.label}}</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-radio-group formControlName="sortDirection" fxFlex="1 1 50%">
                                    <mat-radio-button class="data-type-radio" value="ASC">Ascending
                                    </mat-radio-button>
                                    <mat-radio-button class="data-type-radio" value="DESC">Descending
                                    </mat-radio-button>
                                </mat-radio-group>

                            </div> -->
                            <mat-checkbox formControlName="useAbsoluteValue">Use
                                absolute value</mat-checkbox>
                            <mat-form-field width="10%">
                                <input matInput type="number" min="0" [max]="maxLimitRows" placeholder="Limit # of Results to..."
                                    formControlName="topNCount">
                            </mat-form-field>
                            <mat-form-field [fxHide]="componentType.value !== 'COMPARISON_TABLE'">
                                <mat-select placeholder="Comparison Date Type" formControlName="comparisonDateType">
                                    <mat-option [value]="'PREVIOUS_DAY'">Previous Day</mat-option>
                                    <mat-option [value]="'START_OF_WEEK'">Start of Week</mat-option>
                                    <mat-option [value]="'START_OF_MONTH'">Start of Month</mat-option>
                                    <mat-option [value]="'START_OF_QUARTER'">Start of Quarter</mat-option>
                                    <mat-option [value]="'START_OF_YEAR'">Start of Year</mat-option>
                                    <mat-option [value]="'WEEK_ON_WEEK'">Week on Week</mat-option>
                                    <mat-option [value]="'MONTH_ON_MONTH'">Month on Month</mat-option>
                                    <mat-option [value]="'SPECIFIC'">Specific</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field
                                [fxHide]="componentType.value !== 'COMPARISON_TABLE' || comparisonDateType.value !== 'SPECIFIC'">
                                <input matInput [matDatepicker]="comparisonDateDatePicker"
                                    formControlName="comparisonDate" name="settleDate"
                                    placeholder="Specific Comparison Date">
                                <mat-datepicker-toggle matSuffix [for]="comparisonDateDatePicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #comparisonDateDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </mat-tab>
                    <mat-tab label="Permissions" *ngIf="!permissionsDisabled" fxFlex="1 1 auto" fxLayout="column">
                        <app-report-dashboard-permission #permission [designers]="designers"
                            [reportDashboardPersistedConfig]="reportDashboardPersistedConfig"
                            (formReady)="addFormControl('permissions', $event)">
                        </app-report-dashboard-permission>
                    </mat-tab>
                    <mat-tab fxFlex="1 1 auto" fxLayout="column" label="Conditionality (Liquitics Use Only)"
                        [disabled]="conditionalityDisabled">
                        <mat-button-toggle-group fxFlex="0 0 auto" color="primary" appearance="legacy"
                            formControlName="conditionalityRequirementType">
                            <mat-button-toggle class="configuration-toggle-button" value="ALL">All sets must apply
                            </mat-button-toggle>
                            <mat-button-toggle class="configuration-toggle-button" value="ANY">If any set applies
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                        <button mat-icon-button aria-label="Add Condition Set" (click)="onAddConditionSet()">
                            <mat-icon>add</mat-icon>
                        </button>
                        <p-tabView>
                            <p-tabPanel
                                *ngFor="let requirement of reportDashboardComponentConfig.conditionalRelevanceConfig.conditionRequirements; let i = index"
                                [header]="'Condition Set #' + (i+1)" fxLayout="column">
                                <app-report-dashboard-query-filter [columnGroupLabels]="['Attributes','Values']"
                                    [columnGroups]="sourceQueryFilterColumnGroups()"
                                    [distinctValues]="distinctValues" [customerColumnAliases]="customerColumnAliases"
                                    [queryFilters]="requirement.conditions">
                                </app-report-dashboard-query-filter>
                            </p-tabPanel>
                        </p-tabView>

                    </mat-tab>
                </mat-tab-group>
            </form>
        </div>
    </mat-dialog-content>
    <div class="spacer"></div>
    <mat-dialog-actions align="end">
        <!-- <button mat-button (click)="debug()">Debug</button> -->
        <mat-error *ngIf="!queryFormGroup.valid">
            <!-- <span *ngIf="queryFormGroup.hasError('pivotRowColumns')">Row columns are required</span>
            <span *ngIf="queryFormGroup.hasError('pivotColColumns')">Column columns are required</span>
            <span *ngIf="queryFormGroup.hasError('attributeColumns')">Attribute columns are required</span>
            <span *ngIf="queryFormGroup.hasError('valueColumns')">Value columns are required</span>
            <span *ngIf="queryFormGroup.hasError('attributeColumn')">Attribute column is required</span>
            <span *ngIf="queryFormGroup.hasError('valueColumn')">Value column is required</span> -->
            <span *ngIf="queryFormGroup.hasError('attributeColumnsMax')">Maximum attribute column count exceeded</span>
            <span *ngIf="queryFormGroup.hasError('valueColumnsMax')">Maximum value column count exceeded</span>
            <span *ngIf="queryFormGroup.hasError('maxPivotAttributes')">Maximum pivot column + row column count
                exceeded</span>
            <span *ngIf="queryFormGroup.hasError('duplicatePivotAttributes')">The same column cannot be used for pivot
                rows and columns</span>
            <span *ngIf="queryFormGroup.hasError('invalidColumn')">Invalid Column selected</span>

            <span
                *ngIf="queryFormGroup.hasError('invalidFieldDisplay')">{{queryFormGroup.getError('invalidFieldDisplay')}}</span>

        </mat-error>
        <button mat-button [mat-dialog-close]>Cancel</button>
        <button mat-button [mat-dialog-close]="getDialogReturnValue()" color="primary"
            [disabled]="!queryFormGroup.valid" (click)="onOKButton()">{{okButtonLabel}}</button>

    </mat-dialog-actions>
</div>

<ng-template #presetOptions let-modulus="modulus">
    <div fxLayout="column">
        <ng-container *ngIf="selectedPresetOptionAndValuesGroups && selectedPresetOptionAndValuesGroups.length > 0">
            <ng-container *ngFor="let group of selectedPresetOptionAndValuesGroups">
                <fieldset fxFlex="1 1 auto" fxLayout="row wrap" class="field-set">
                    <legend>{{group.name}}</legend>
                    <ng-container *ngIf="group.optionAndValues && group.optionAndValues.length > 0">
                        <ng-container *ngFor="let optionAndValue of group.optionAndValues; let i = index"
                            fxLayout="row">
                            <!-- <ng-container *ngIf="i % 2 === modulus"> -->
                            <mat-form-field
                                *ngIf="optionAndValue.option.type === 'STRING' && (!optionAndValue.option.choices || optionAndValue.option.choices.length === 0)"
                                [fxFlex]="presetOptionFXFlex(optionAndValue, '25%')"
                                class="preset-option-mat-form-field">
                                <mat-label>{{optionLabelToDisplayName(optionAndValue.option.name)}}</mat-label>
                                <input matInput [placeholder]="optionAndValue.option.description"
                                    [(ngModel)]="optionAndValue.value">
                                <mat-hint>{{optionAndValue.option.hints}}</mat-hint>
                            </mat-form-field>
                            <mat-form-field *ngIf="optionAndValue.option.type === 'NUMBER'"
                                [fxFlex]="presetOptionFXFlex(optionAndValue, '10%')"
                                class="preset-option-mat-form-field">
                                <mat-label>{{optionLabelToDisplayName(optionAndValue.option.name)}}</mat-label>
                                <input matInput type="number" [(ngModel)]="optionAndValue.value">
                                <mat-hint>{{optionAndValue.option.hints}}</mat-hint>
                            </mat-form-field>
                            <mat-form-field
                                *ngIf="optionAndValue.option.type === 'STRING' && optionAndValue.option.choices && optionAndValue.option.choices.length > 0"
                                [fxFlex]="presetOptionFXFlex(optionAndValue, '25%')"
                                class="preset-option-mat-form-field">
                                <mat-label>{{optionLabelToDisplayName(optionAndValue.option.name)}}</mat-label>
                                <mat-select [(ngModel)]="optionAndValue.value"
                                    [multiple]="optionAndValue.option.multiChoice">
                                    <mat-option *ngFor="let choice of optionAndValue.option.choices"
                                        [value]="choice">{{choice}}
                                    </mat-option>
                                </mat-select>
                                <mat-hint>{{optionAndValue.option.hints}}</mat-hint>
                            </mat-form-field>
                            <div *ngIf="optionAndValue.option.type === 'BOOLEAN'" fxLayout="column"
                                [fxFlex]="presetOptionFXFlex(optionAndValue, '10%')"
                                class="preset-option-mat-form-field preset-option-checkbox">
                                <mat-checkbox [(ngModel)]="optionAndValue.value">
                                    {{optionLabelToDisplayName(optionAndValue.option.name)}}</mat-checkbox>
                                <mat-hint>{{optionAndValue.option.hints}}</mat-hint>
                            </div>
                            <mat-form-field *ngIf="optionAndValue.option.type === 'METRIC'"
                                [fxFlex]="presetOptionFXFlex(optionAndValue, '75%')"
                                class="preset-option-mat-form-field">
                                <mat-label>{{optionLabelToDisplayName(optionAndValue.option.name)}}</mat-label>
                                <!-- <mat-select [(ngModel)]="optionAndValue.value" [multiple]="optionAndValue.option.multiChoice">
                        <mat-option *ngFor="let metricChoice of allMetricChoices" [value]="metricChoice.value">
                            {{metricChoice.label}}</mat-option>
                    </mat-select> -->
                                <app-chooser-bar #listChooserBar fxFlex="1 1 100%"
                                    [maxAllowed]="optionAndValue.option.multiChoice ? 30 : 1" [chooserBarType]="'LIST'"
                                    [items]="allMetricChoices" [ordered]="true" [(ngModel)]="optionAndValue.value">
                                </app-chooser-bar>
                                <mat-hint>{{optionAndValue.option.hints}}</mat-hint>
                            </mat-form-field>
                            <mat-form-field *ngIf="optionAndValue.option.type === 'DATETIME'"
                                [fxFlex]="presetOptionFXFlex(optionAndValue, '25%')"
                                class="preset-option-mat-form-field">
                                <input matInput type="datetime-local"
                                    [placeholder]="optionLabelToDisplayName(optionAndValue.option.name)"
                                    [(ngModel)]="optionAndValue.value">
                            </mat-form-field>
                            <mat-form-field *ngIf="optionAndValue.option.type === 'DATE'"
                                [fxFlex]="presetOptionFXFlex(optionAndValue, '25%')"
                                class="preset-option-mat-form-field">
                                <input matInput [matDatepicker]="optionAndValueDatePicker"
                                    [(ngModel)]="optionAndValue.value"
                                    [placeholder]="optionLabelToDisplayName(optionAndValue.option.name)">
                                <mat-datepicker-toggle matSuffix [for]="optionAndValueDatePicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #optionAndValueDatePicker></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field *ngIf="optionAndValue.option.type === 'LIST'"
                                [fxFlex]="presetOptionFXFlex(optionAndValue, '75%')"
                                class="preset-option-mat-form-field">
                                <mat-label>{{optionLabelToDisplayName(optionAndValue.option.name)}}</mat-label>
                                <app-chooser-bar #listChooserBar fxFlex="1 1 100%" [maxAllowed]="30"
                                    [chooserBarType]="'LIST'" [items]="[]" [ordered]="false"
                                    [(ngModel)]="optionAndValue.value">
                                </app-chooser-bar>
                            </mat-form-field>
                            <mat-form-field *ngIf="optionAndValue.option.type === 'ATTRIBUTE_COLUMN'"
                                [fxFlex]="presetOptionFXFlex(optionAndValue, '25%')"
                                class="preset-option-mat-form-field">
                                <mat-label>{{optionLabelToDisplayName(optionAndValue.option.name)}}</mat-label>
                                <mat-select [(ngModel)]="optionAndValue.value">
                                    <mat-option *ngFor="let attributeColumn of (optionAndValue.selectItems || [])"
                                        [value]="attributeColumn.value" #attributeOption>
                                        {{attributeColumn.label}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field *ngIf="optionAndValue.option.type === 'VALUE_COLUMN'"
                                [fxFlex]="presetOptionFXFlex(optionAndValue, '25%')"
                                class="preset-option-mat-form-field">
                                <mat-label>{{optionLabelToDisplayName(optionAndValue.option.name)}}</mat-label>
                                <mat-select [(ngModel)]="optionAndValue.value">
                                    <mat-option *ngFor="let valueColumn of (optionAndValue.selectItems || [])"
                                        [value]="valueColumn.value" #valueOption>
                                        {{valueColumn.label}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div *ngIf="optionAndValue.option.type === 'SPACER'" class="preset-option" fxLayout="column"
                                [fxFlex]="presetOptionFXFlex(optionAndValue, '100%')"
                                class="preset-option-mat-form-field">
                                <span fxFlex="1 1 100%"> </span>
                            </div>
                            <i *ngIf="optionAndValue.option.type !== 'BOOLEAN' && optionAndValue.option.type !== 'SPACER'"
                                class="pi pi-times-circle clear-option-value-icon"
                                (click)="optionAndValue.value = undefined"></i>
                            <!-- </ng-container> -->
                        </ng-container>
                    </ng-container>
                </fieldset>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #metricType>
    <mat-button-toggle-group fxFlex="1 1 25%" color="primary" appearance="legacy"
        *ngIf="data.isMetricDefinition && reportDashboardMetricDefinition"
        [(ngModel)]="reportDashboardMetricDefinition.type" (change)="onQueryTypeChange($event)">
        <mat-button-toggle class="configuration-toggle-button" [value]="'QUERY_BASED'">
            Query Based
        </mat-button-toggle>
        <mat-button-toggle class="configuration-toggle-button" [value]="'RATIO'">Ratio
        </mat-button-toggle>
        <mat-button-toggle class="configuration-toggle-button" [value]="'PRESET_BASED'">Preset Based
        </mat-button-toggle>
    </mat-button-toggle-group>
</ng-template>
<ng-template #metricFields>
    <div *ngIf="reportDashboardMetricDefinition" fxLayout="column">
        <ng-container *ngIf="reportDashboardMetricDefinition.type === 'RATIO'">
            <div fxLayout="row">
                <mat-form-field fxFlex="1 1 75%">
                    <mat-label>Numerator Metric</mat-label>
                    <mat-select [(ngModel)]="reportDashboardMetricDefinition.ratio.numeratorMetricName">
                        <mat-option *ngFor="let metricChoice of metricDefinitionUsableMetricChoices"
                            [value]="metricChoice.value">
                            {{metricChoice.label}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div fxLayout="row">
                <mat-form-field fxFlex="1 1 75%">
                    <mat-label>Denominator Metric</mat-label>
                    <mat-select [(ngModel)]="reportDashboardMetricDefinition.ratio.denominatorMetricName">
                        <mat-option *ngFor="let metricChoice of metricDefinitionUsableMetricChoices"
                            [value]="metricChoice.value">
                            {{metricChoice.label}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </ng-container>
        <div fxLayout="row">
            <mat-form-field fxFlex="1 1 10%">
                <input matInput type="number" min="0" max="6" placeholder="Decimals"
                    [(ngModel)]="reportDashboardMetricDefinition.decimalPlaces">
            </mat-form-field>
            <mat-form-field fxFlex="1 1 15%">
                <mat-label>Scaling</mat-label>
                <mat-select [(ngModel)]="reportDashboardMetricDefinition.scaling">
                    <mat-option [value]="1">None</mat-option>
                    <mat-option [value]="100">Percentage</mat-option>
                    <mat-option [value]="10000">Basis Points</mat-option>
                    <mat-option [value]="0.001">Thousand</mat-option>
                    <mat-option [value]="0.000001">Million</mat-option>
                    <mat-option [value]="0.000000001">Billion</mat-option>
                    <mat-option [value]="0.00001">Lakh</mat-option>
                    <mat-option [value]="0.0000001">Crore</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field fxFlex="1 1 15%">
                <mat-label>Modifier</mat-label>
                <mat-select [(ngModel)]="reportDashboardMetricDefinition.sign">
                    <mat-option [value]="'ACTUAL'">None</mat-option>
                    <mat-option [value]="'UNSIGNED'">Unsigned</mat-option>
                    <mat-option [value]="'REVERSED'">Reverse</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div fxLayout="row">
            <mat-form-field fxFlex="1 1 75%">
                <mat-label>Benchmark</mat-label>
                <mat-select [(ngModel)]="reportDashboardMetricDefinition.benchmark.name">
                    <mat-option *ngFor="let benchmarkChoice of benchmarkChoices" [value]="benchmarkChoice.value.name">
                        {{benchmarkChoice.label}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div fxLayout="row">
            <mat-form-field fxFlex="1 1 10%">
                <input matInput type="number" min="0" max="6" placeholder="Benchmark Decimals"
                    [(ngModel)]="reportDashboardMetricDefinition.benchmark.decimalPlaces">
            </mat-form-field>
        </div>
    </div>
</ng-template>